var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_149759",
    "data-name": "Group 149759",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 320.995,
    height: 239.211,
    viewBox: "0 0 320.995 239.211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54551",
    "data-name": "Rectangle 54551",
    width: 320.995,
    height: 239.211,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54539",
    "data-name": "Rectangle 54539",
    width: 320.995,
    height: 239.211,
    fill: "#014cec"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54541",
    "data-name": "Rectangle 54541",
    width: 32.696,
    height: 31.757,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54543",
    "data-name": "Rectangle 54543",
    width: 7.846,
    height: 8.491,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54544",
    "data-name": "Rectangle 54544",
    width: 6.155,
    height: 7.014,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54545",
    "data-name": "Rectangle 54545",
    width: 11.646,
    height: 16.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54546",
    "data-name": "Rectangle 54546",
    width: 4.762,
    height: 10.899,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54547",
    "data-name": "Rectangle 54547",
    width: 31.6,
    height: 37.377,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54548",
    "data-name": "Rectangle 54548",
    width: 6.698,
    height: 31.849,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54549",
    "data-name": "Rectangle 54549",
    width: 14.287,
    height: 15.883,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_149758",
    "data-name": "Group 149758",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54512",
    "data-name": "Rectangle 54512",
    width: 320.995,
    height: 0.16,
    transform: "translate(0 210.217)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54513",
    "data-name": "Rectangle 54513",
    width: 10.632,
    height: 0.16,
    transform: "translate(252.37 220.631)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54514",
    "data-name": "Rectangle 54514",
    width: 24.271,
    height: 0.16,
    transform: "translate(211.339 218.299)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54515",
    "data-name": "Rectangle 54515",
    width: 44.349,
    height: 0.16,
    transform: "translate(170.127 214.589)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54516",
    "data-name": "Rectangle 54516",
    width: 8.149,
    height: 0.16,
    transform: "translate(33.678 215.668)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54517",
    "data-name": "Rectangle 54517",
    width: 23.646,
    height: 0.16,
    transform: "translate(47.543 215.668)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54518",
    "data-name": "Rectangle 54518",
    width: 38.217,
    height: 0.16,
    transform: "translate(97.796 218.379)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_149727",
    "data-name": "Group 149727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149726",
    "data-name": "Group 149726",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102397",
    "data-name": "Path 102397",
    d: "M165.839,181.585H41.871a3.669,3.669,0,0,1-3.664-3.664V3.664A3.669,3.669,0,0,1,41.871,0H165.839A3.669,3.669,0,0,1,169.5,3.664V177.921a3.668,3.668,0,0,1-3.664,3.664M41.871.16a3.508,3.508,0,0,0-3.5,3.5V177.921a3.508,3.508,0,0,0,3.5,3.5H165.839a3.508,3.508,0,0,0,3.5-3.5V3.664a3.508,3.508,0,0,0-3.5-3.5Z",
    transform: "translate(-13.678)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102398",
    "data-name": "Path 102398",
    d: "M382.137,181.585H258.169a3.668,3.668,0,0,1-3.664-3.664V3.664A3.668,3.668,0,0,1,258.169,0H382.137A3.669,3.669,0,0,1,385.8,3.664V177.921a3.669,3.669,0,0,1-3.664,3.664M258.169.16a3.507,3.507,0,0,0-3.5,3.5V177.921a3.507,3.507,0,0,0,3.5,3.5H382.137a3.508,3.508,0,0,0,3.5-3.5V3.664a3.508,3.508,0,0,0-3.5-3.5Z",
    transform: "translate(-91.115)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102399",
    "data-name": "Path 102399",
    d: "M96.938,188.608S96.5,198.973,79.6,198.973s-17.334-10.365-17.334-10.365Z",
    transform: "translate(-22.294 -67.523)",
    fill: "#d4e1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102400",
    "data-name": "Path 102400",
    d: "M96.938,176.291S96.5,186.656,79.6,186.656s-17.334-10.365-17.334-10.365Z",
    transform: "translate(-22.294 -63.114)",
    fill: "#d4e1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54519",
    "data-name": "Rectangle 54519",
    width: 13.319,
    height: 70.337,
    transform: "translate(34.04 134.195)",
    fill: "#d1dfff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54520",
    "data-name": "Rectangle 54520",
    width: 112.846,
    height: 5.685,
    transform: "translate(38.9 204.532)",
    fill: "#d1dfff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54521",
    "data-name": "Rectangle 54521",
    width: 109.249,
    height: 70.337,
    transform: "translate(47.358 134.195)",
    fill: "#aec8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54522",
    "data-name": "Rectangle 54522",
    width: 89.343,
    height: 23.393,
    transform: "translate(57.311 141.644)",
    fill: "#014cec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54523",
    "data-name": "Rectangle 54523",
    width: 89.343,
    height: 23.393,
    transform: "translate(57.311 170.404)",
    fill: "#014cec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102401",
    "data-name": "Path 102401",
    d: "M162.365,223.407H141.4a2.018,2.018,0,0,1,0-4.036h20.962a2.018,2.018,0,0,1,0,4.036",
    transform: "translate(-49.901 -78.537)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102402",
    "data-name": "Path 102402",
    d: "M162.365,268.2H141.4a2.018,2.018,0,1,1,0-4.036h20.962a2.018,2.018,0,1,1,0,4.036",
    transform: "translate(-49.901 -94.575)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54524",
    "data-name": "Rectangle 54524",
    width: 112.622,
    height: 2.746,
    transform: "translate(47.358 131.449)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54525",
    "data-name": "Rectangle 54525",
    width: 16.857,
    height: 2.746,
    transform: "translate(30.502 131.449)",
    fill: "#d1dfff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54526",
    "data-name": "Rectangle 54526",
    width: 97.038,
    height: 87.581,
    transform: "translate(181.456 24.679)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54527",
    "data-name": "Rectangle 54527",
    width: 100.371,
    height: 87.581,
    transform: "translate(183.128 24.679)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54528",
    "data-name": "Rectangle 54528",
    width: 88.842,
    height: 76.05,
    transform: "translate(188.89 30.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54529",
    "data-name": "Rectangle 54529",
    width: 7.371,
    height: 70.803,
    transform: "translate(265.541 139.414)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54530",
    "data-name": "Rectangle 54530",
    width: 4.342,
    height: 70.803,
    transform: "translate(270.543 139.414)",
    fill: "#d1dfff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54531",
    "data-name": "Rectangle 54531",
    width: 7.371,
    height: 70.803,
    transform: "translate(234.171 139.414)",
    fill: "#aec8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54532",
    "data-name": "Rectangle 54532",
    width: 4.342,
    height: 70.803,
    transform: "translate(238.582 139.414)",
    fill: "#d1dfff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54533",
    "data-name": "Rectangle 54533",
    width: 64.823,
    height: 13.705,
    transform: "translate(211.407 139.414)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54534",
    "data-name": "Rectangle 54534",
    width: 7.371,
    height: 70.803,
    transform: "translate(172.037 139.414)",
    fill: "#aec8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54535",
    "data-name": "Rectangle 54535",
    width: 4.342,
    height: 70.803,
    transform: "translate(176.449 139.414)",
    fill: "#d1dfff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54536",
    "data-name": "Rectangle 54536",
    width: 37.533,
    height: 13.705,
    transform: "translate(170.72 139.414)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54537",
    "data-name": "Rectangle 54537",
    width: 7.371,
    height: 70.803,
    transform: "translate(203.408 139.414)",
    fill: "#aec8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54538",
    "data-name": "Rectangle 54538",
    width: 4.342,
    height: 70.803,
    transform: "translate(208.41 139.414)",
    fill: "#d1dfff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_149729",
    "data-name": "Group 149729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149728",
    "data-name": "Group 149728",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102403",
    "data-name": "Path 102403",
    d: "M305.061,357.232c0,4.015-55.729,7.269-124.475,7.269s-124.475-3.254-124.475-7.269,55.729-7.269,124.475-7.269,124.475,3.255,124.475,7.269",
    transform: "translate(-20.088 -125.29)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_149734",
    "data-name": "Group 149734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149733",
    "data-name": "Group 149733",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102404",
    "data-name": "Path 102404",
    d: "M81.066,158.159l-7.9-137.428a4.642,4.642,0,0,1,4.685-4.97H234.584a5.332,5.332,0,0,1,5.256,4.97l7.9,137.428a4.641,4.641,0,0,1-4.685,4.97H86.322a5.331,5.331,0,0,1-5.256-4.97",
    transform: "translate(-26.192 -5.643)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102405",
    "data-name": "Path 102405",
    d: "M242.883,163.265H86.152a5.647,5.647,0,0,1-5.56-5.257L72.693,20.58a4.946,4.946,0,0,1,4.99-5.293H234.414a5.647,5.647,0,0,1,5.56,5.258l7.9,137.427a4.947,4.947,0,0,1-4.99,5.293M81.2,157.972a5.029,5.029,0,0,0,4.952,4.683H242.883a4.336,4.336,0,0,0,4.38-4.648l-7.9-137.428a5.029,5.029,0,0,0-4.952-4.683H77.683A4.338,4.338,0,0,0,73.3,20.545Z",
    transform: "translate(-26.022 -5.473)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102406",
    "data-name": "Path 102406",
    d: "M84.056,158.159l-7.9-137.428a4.642,4.642,0,0,1,4.685-4.97H237.574a5.332,5.332,0,0,1,5.256,4.97l7.9,137.428a4.641,4.641,0,0,1-4.685,4.97H89.312a5.331,5.331,0,0,1-5.256-4.97",
    transform: "translate(-27.262 -5.643)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102407",
    "data-name": "Path 102407",
    d: "M245.873,163.265H89.143a5.646,5.646,0,0,1-5.56-5.258L75.683,20.58a4.946,4.946,0,0,1,4.99-5.293H237.4a5.647,5.647,0,0,1,5.56,5.257l7.9,137.428a4.948,4.948,0,0,1-4.99,5.293M80.673,15.9a4.337,4.337,0,0,0-4.381,4.648l7.9,137.428a5.03,5.03,0,0,0,4.952,4.683h156.73a4.337,4.337,0,0,0,4.38-4.649l-7.9-137.427A5.029,5.029,0,0,0,237.4,15.9Z",
    transform: "translate(-27.092 -5.473)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102408",
    "data-name": "Path 102408",
    d: "M144.367,43.385h-43.8a3.173,3.173,0,0,1-3.118-2.949,2.761,2.761,0,0,1,2.779-2.949h43.8a3.173,3.173,0,0,1,3.118,2.949,2.761,2.761,0,0,1-2.779,2.949",
    transform: "translate(-34.886 -13.421)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102409",
    "data-name": "Path 102409",
    d: "M136.642,59.3H101.481a3.173,3.173,0,0,1-3.119-2.949,2.762,2.762,0,0,1,2.78-2.949H136.3a3.173,3.173,0,0,1,3.118,2.949,2.761,2.761,0,0,1-2.779,2.949",
    transform: "translate(-35.213 -19.118)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102410",
    "data-name": "Path 102410",
    d: "M154.3,81H101.651a2.043,2.043,0,0,1-2.014-1.9,1.778,1.778,0,0,1,1.8-1.9h52.652a2.043,2.043,0,0,1,2.014,1.9A1.779,1.779,0,0,1,154.3,81",
    transform: "translate(-35.67 -27.635)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102411",
    "data-name": "Path 102411",
    d: "M167.227,90.462h-56a2.043,2.043,0,0,1-2.014-1.9,1.778,1.778,0,0,1,1.8-1.9h56a2.043,2.043,0,0,1,2.014,1.9,1.779,1.779,0,0,1-1.8,1.9",
    transform: "translate(-39.097 -31.023)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102412",
    "data-name": "Path 102412",
    d: "M157.517,99.923h-45.75a2.043,2.043,0,0,1-2.014-1.9,1.778,1.778,0,0,1,1.8-1.9H157.3a2.043,2.043,0,0,1,2.014,1.9,1.778,1.778,0,0,1-1.795,1.9",
    transform: "translate(-39.292 -34.41)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102413",
    "data-name": "Path 102413",
    d: "M152.895,109.383H112.311a2.043,2.043,0,0,1-2.014-1.9,1.778,1.778,0,0,1,1.8-1.9h40.583a2.043,2.043,0,0,1,2.014,1.9,1.779,1.779,0,0,1-1.795,1.9",
    transform: "translate(-39.486 -37.797)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102414",
    "data-name": "Path 102414",
    d: "M137.042,124.777H104.167a2.043,2.043,0,0,1-2.014-1.9,1.778,1.778,0,0,1,1.8-1.9h32.875a2.043,2.043,0,0,1,2.014,1.9,1.779,1.779,0,0,1-1.8,1.9",
    transform: "translate(-36.571 -43.308)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102415",
    "data-name": "Path 102415",
    d: "M150.182,149.349H114.608a1.779,1.779,0,0,0-1.8,1.9,2.043,2.043,0,0,0,2.014,1.9H150.4a1.778,1.778,0,0,0,1.8-1.9,2.043,2.043,0,0,0-2.014-1.9",
    transform: "translate(-40.387 -53.468)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102416",
    "data-name": "Path 102416",
    d: "M142.886,139.889H114.064a1.778,1.778,0,0,0-1.8,1.9,2.042,2.042,0,0,0,2.014,1.9h28.822a1.778,1.778,0,0,0,1.8-1.9,2.043,2.043,0,0,0-2.014-1.9",
    transform: "translate(-40.192 -50.082)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102417",
    "data-name": "Path 102417",
    d: "M145.651,130.428h-32.13a1.778,1.778,0,0,0-1.8,1.9,2.042,2.042,0,0,0,2.014,1.9h32.13a1.778,1.778,0,0,0,1.8-1.9,2.042,2.042,0,0,0-2.014-1.9",
    transform: "translate(-39.998 -46.694)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102418",
    "data-name": "Path 102418",
    d: "M141.19,196.934H108.315a2.043,2.043,0,0,1-2.014-1.9,1.778,1.778,0,0,1,1.8-1.9h32.875a2.042,2.042,0,0,1,2.014,1.9,1.778,1.778,0,0,1-1.8,1.9",
    transform: "translate(-38.056 -69.141)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102419",
    "data-name": "Path 102419",
    d: "M154.329,221.506H118.755a1.779,1.779,0,0,0-1.8,1.9,2.043,2.043,0,0,0,2.014,1.9h35.574a1.778,1.778,0,0,0,1.795-1.9,2.043,2.043,0,0,0-2.014-1.9",
    transform: "translate(-41.872 -79.301)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102420",
    "data-name": "Path 102420",
    d: "M147.034,212.046H118.212a1.778,1.778,0,0,0-1.8,1.9,2.042,2.042,0,0,0,2.014,1.9h28.822a1.778,1.778,0,0,0,1.795-1.9,2.042,2.042,0,0,0-2.014-1.9",
    transform: "translate(-41.677 -75.914)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102421",
    "data-name": "Path 102421",
    d: "M149.8,202.585h-32.13a1.778,1.778,0,0,0-1.8,1.9,2.042,2.042,0,0,0,2.014,1.9h32.13a1.778,1.778,0,0,0,1.8-1.9,2.042,2.042,0,0,0-2.014-1.9",
    transform: "translate(-41.483 -72.527)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102422",
    "data-name": "Path 102422",
    d: "M151.813,177.731H116.239a1.779,1.779,0,0,0-1.795,1.9,2.043,2.043,0,0,0,2.014,1.9h35.574a1.778,1.778,0,0,0,1.795-1.9,2.043,2.043,0,0,0-2.014-1.9",
    transform: "translate(-40.971 -63.629)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102423",
    "data-name": "Path 102423",
    d: "M144.518,168.27H115.7a1.778,1.778,0,0,0-1.8,1.9,2.042,2.042,0,0,0,2.014,1.9h28.822a1.778,1.778,0,0,0,1.8-1.9,2.043,2.043,0,0,0-2.014-1.9",
    transform: "translate(-40.777 -60.242)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102424",
    "data-name": "Path 102424",
    d: "M147.282,158.81h-32.13a1.778,1.778,0,0,0-1.8,1.9,2.042,2.042,0,0,0,2.014,1.9H147.5a1.778,1.778,0,0,0,1.8-1.9,2.043,2.043,0,0,0-2.014-1.9",
    transform: "translate(-40.582 -56.855)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102425",
    "data-name": "Path 102425",
    d: "M241.829,63.438H225.951A17.032,17.032,0,0,1,209.16,47.559a14.827,14.827,0,0,1,14.965-15.878,17.032,17.032,0,0,1,16.791,15.878Z",
    transform: "translate(-74.872 -11.342)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102426",
    "data-name": "Path 102426",
    d: "M227.329,62.221h0a14.082,14.082,0,0,1-13.882-13.128A12.259,12.259,0,0,1,225.82,35.966,14.081,14.081,0,0,1,239.7,49.093a12.259,12.259,0,0,1-12.373,13.128",
    transform: "translate(-76.408 -12.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102427",
    "data-name": "Path 102427",
    d: "M233.094,48.135l.611,10.631h-2.938l-.4-6.966a8.285,8.285,0,0,1-1.33.878,10.194,10.194,0,0,1-1.634.641l-.137-2.381a6.585,6.585,0,0,0,2.236-1.148,4.31,4.31,0,0,0,1.188-1.654Z",
    transform: "translate(-81.363 -17.233)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102428",
    "data-name": "Path 102428",
    d: "M274.8,112.9H290.68a14.827,14.827,0,0,0,14.965-15.878,17.032,17.032,0,0,0-16.791-15.878,14.828,14.828,0,0,0-14.966,15.878Z",
    transform: "translate(-98.045 -29.051)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102429",
    "data-name": "Path 102429",
    d: "M292.058,111.687h0a12.259,12.259,0,0,0,12.373-13.128,14.081,14.081,0,0,0-13.882-13.127,12.259,12.259,0,0,0-12.373,13.127,14.082,14.082,0,0,0,13.882,13.128",
    transform: "translate(-99.582 -30.585)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102430",
    "data-name": "Path 102430",
    d: "M301.364,108.232H292.65a5.182,5.182,0,0,1,.77-2.428,11.241,11.241,0,0,1,2.694-2.684,7.8,7.8,0,0,0,1.55-1.441,1.532,1.532,0,0,0,.3-.933,1.163,1.163,0,0,0-.4-.817,1.3,1.3,0,0,0-.907-.339,1.171,1.171,0,0,0-.889.349,2.026,2.026,0,0,0-.4,1.234l-2.923-.236a4.43,4.43,0,0,1,.517-1.914,2.683,2.683,0,0,1,1.226-1.055,5.657,5.657,0,0,1,2.278-.367,6.655,6.655,0,0,1,2.406.349,3.155,3.155,0,0,1,1.4,1.073,2.984,2.984,0,0,1,.582,1.622,3.179,3.179,0,0,1-.455,1.825,7.033,7.033,0,0,1-1.926,1.911q-.842.606-1.124.848t-.658.635h4.534Z",
    transform: "translate(-104.698 -34.942)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_149732",
    "data-name": "Group 149732",
    transform: "translate(137.912 83.852)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149731",
    "data-name": "Group 149731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149730",
    "data-name": "Group 149730",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102431",
    "data-name": "Path 102431",
    d: "M247.515,162.37H231.637a17.032,17.032,0,0,1-16.791-15.878,14.827,14.827,0,0,1,14.965-15.878A17.032,17.032,0,0,1,246.6,146.491Z",
    transform: "translate(-214.819 -130.613)",
    fill: "#407bff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_102432",
    "data-name": "Path 102432",
    d: "M233.015,161.154h0a14.082,14.082,0,0,1-13.882-13.128A12.259,12.259,0,0,1,231.506,134.9a14.081,14.081,0,0,1,13.882,13.127,12.258,12.258,0,0,1-12.373,13.128",
    transform: "translate(-78.444 -48.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102433",
    "data-name": "Path 102433",
    d: "M235.645,150.129l-2.773-.492a3.2,3.2,0,0,1,1.2-2.011,4.479,4.479,0,0,1,2.716-.7,4.8,4.8,0,0,1,3,.763,2.556,2.556,0,0,1,1.023,1.918,2.058,2.058,0,0,1-.3,1.227,2.9,2.9,0,0,1-1.064.962,3.484,3.484,0,0,1,.948.349,2.462,2.462,0,0,1,.858.845,2.669,2.669,0,0,1,.361,1.251,3.357,3.357,0,0,1-.378,1.751,2.943,2.943,0,0,1-1.3,1.29,5.1,5.1,0,0,1-2.334.453,6.279,6.279,0,0,1-2.269-.335,3.64,3.64,0,0,1-1.411-.98,4.833,4.833,0,0,1-.91-1.622l2.88-.385a2.411,2.411,0,0,0,.6,1.215,1.353,1.353,0,0,0,.935.339,1.186,1.186,0,0,0,.949-.428,1.555,1.555,0,0,0,.323-1.141,1.667,1.667,0,0,0-.439-1.127,1.4,1.4,0,0,0-1.039-.4,3.585,3.585,0,0,0-.932.171l.031-2.074a2.81,2.81,0,0,0,.38.035,1.256,1.256,0,0,0,.931-.363,1.163,1.163,0,0,0,0-1.626,1.118,1.118,0,0,0-.8-.285,1.09,1.09,0,0,0-.817.31,1.777,1.777,0,0,0-.372,1.088",
    transform: "translate(-83.37 -52.601)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102434",
    "data-name": "Path 102434",
    d: "M280.488,211.836h15.878a14.827,14.827,0,0,0,14.965-15.878,17.032,17.032,0,0,0-16.791-15.878,14.828,14.828,0,0,0-14.966,15.878Z",
    transform: "translate(-100.081 -64.47)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102435",
    "data-name": "Path 102435",
    d: "M297.745,210.618h0a12.258,12.258,0,0,0,12.373-13.128,14.081,14.081,0,0,0-13.882-13.127h0a12.259,12.259,0,0,0-12.373,13.127,14.082,14.082,0,0,0,13.882,13.128",
    transform: "translate(-101.618 -66.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102436",
    "data-name": "Path 102436",
    d: "M302.384,205.21h-5.291l-.137-2.389,4.929-6.289h2.531l.37,6.424H306.1l.13,2.253h-1.312l.112,1.954H302.5Zm-.13-2.253-.189-3.29-2.607,3.29Z",
    transform: "translate(-106.313 -70.36)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102437",
    "data-name": "Path 102437",
    d: "M269.608,144.909a.562.562,0,0,1-.561-.53L265.4,80.865a.563.563,0,1,1,1.124-.064l3.65,63.513a.562.562,0,0,1-.53.594h-.033",
    transform: "translate(-95.014 -28.737)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102438",
    "data-name": "Path 102438",
    d: "M273.47,212.084a.562.562,0,0,1-.561-.53L271.083,179.8a.563.563,0,1,1,1.124-.064l1.825,31.757a.562.562,0,0,1-.53.594h-.033",
    transform: "translate(-97.05 -64.156)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102439",
    "data-name": "Path 102439",
    d: "M266.8,80.485a1.109,1.109,0,0,1-1.12,1.188,1.274,1.274,0,0,1-1.256-1.188,1.11,1.11,0,0,1,1.12-1.188,1.274,1.274,0,0,1,1.256,1.188",
    transform: "translate(-94.665 -28.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102440",
    "data-name": "Path 102440",
    d: "M265.363,81.922a1.845,1.845,0,0,1-1.818-1.718,1.672,1.672,0,0,1,1.681-1.782,1.846,1.846,0,0,1,1.818,1.718,1.672,1.672,0,0,1-1.682,1.782m-.136-2.375a.548.548,0,0,0-.558.593.715.715,0,0,0,.694.657.547.547,0,0,0,.558-.594.714.714,0,0,0-.695-.657",
    transform: "translate(-94.351 -28.076)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102441",
    "data-name": "Path 102441",
    d: "M269.64,129.951a1.109,1.109,0,0,1-1.12,1.188,1.274,1.274,0,0,1-1.256-1.188,1.11,1.11,0,0,1,1.12-1.188,1.274,1.274,0,0,1,1.256,1.188",
    transform: "translate(-95.682 -46.098)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102442",
    "data-name": "Path 102442",
    d: "M268.206,131.387a1.845,1.845,0,0,1-1.818-1.719,1.672,1.672,0,0,1,1.681-1.782,1.845,1.845,0,0,1,1.817,1.718h0a1.671,1.671,0,0,1-1.681,1.782m-.136-2.376a.548.548,0,0,0-.558.594.715.715,0,0,0,.694.657.546.546,0,0,0,.558-.594.715.715,0,0,0-.694-.657",
    transform: "translate(-95.368 -45.784)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102443",
    "data-name": "Path 102443",
    d: "M272.483,179.417a1.109,1.109,0,0,1-1.12,1.188,1.274,1.274,0,0,1-1.256-1.188,1.109,1.109,0,0,1,1.12-1.188,1.274,1.274,0,0,1,1.256,1.188",
    transform: "translate(-96.7 -63.808)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102444",
    "data-name": "Path 102444",
    d: "M271.049,180.853a1.846,1.846,0,0,1-1.818-1.719,1.671,1.671,0,0,1,1.681-1.782,1.845,1.845,0,0,1,1.817,1.717,1.671,1.671,0,0,1-1.681,1.783m-.137-2.375a.548.548,0,0,0-.558.593.715.715,0,0,0,.695.658.546.546,0,0,0,.557-.593h0a.713.713,0,0,0-.694-.657",
    transform: "translate(-96.386 -63.494)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102445",
    "data-name": "Path 102445",
    d: "M275.326,228.883a1.109,1.109,0,0,1-1.12,1.188,1.274,1.274,0,0,1-1.256-1.188,1.11,1.11,0,0,1,1.12-1.188,1.274,1.274,0,0,1,1.256,1.188",
    transform: "translate(-97.718 -81.517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102446",
    "data-name": "Path 102446",
    d: "M273.892,230.319a1.846,1.846,0,0,1-1.818-1.718,1.672,1.672,0,0,1,1.681-1.783,1.846,1.846,0,0,1,1.818,1.719,1.673,1.673,0,0,1-1.681,1.782m-.137-2.376a.548.548,0,0,0-.558.594.715.715,0,0,0,.695.657.557.557,0,0,0,.41-.171.563.563,0,0,0,.148-.423.715.715,0,0,0-.695-.657",
    transform: "translate(-97.404 -81.203)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_149757",
    "data-name": "Group 149757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149756",
    "data-name": "Group 149756",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102447",
    "data-name": "Path 102447",
    d: "M420.728,99.565c.431.671.779,1.241,1.127,1.871s.68,1.235,1,1.859c.651,1.246,1.237,2.523,1.791,3.816a51.574,51.574,0,0,1,2.662,8.058l.223,1.051.111.525.028.132.046.266c.031.18.039.344.053.516a6.886,6.886,0,0,1-.636,3.077,16.613,16.613,0,0,1-2.524,3.923,36.67,36.67,0,0,1-6.166,5.774l-2.052-2.156a71.738,71.738,0,0,0,4.442-6.324,14.508,14.508,0,0,0,1.46-3.053,1.745,1.745,0,0,0,.1-.851c-.008.005-.006,0-.011.016a.037.037,0,0,0,0,.019l-.033-.112-.133-.452-.265-.9a60.426,60.426,0,0,0-2.778-7.089c-.53-1.163-1.113-2.3-1.693-3.444-.293-.568-.6-1.132-.906-1.687s-.636-1.131-.915-1.6Z",
    transform: "translate(-148.811 -35.645)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102448",
    "data-name": "Path 102448",
    d: "M416.391,142.5l-4.828.2,1.943,4.145s3.435-.195,4.724-2.278Z",
    transform: "translate(-147.343 -51.015)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102449",
    "data-name": "Path 102449",
    d: "M409.7,144.671l1.193,3.709,1.945-1.429-1.943-4.145Z",
    transform: "translate(-146.678 -51.126)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102450",
    "data-name": "Path 102450",
    d: "M404.317,351.674a7.133,7.133,0,0,0,1.554-.211.14.14,0,0,0,.107-.111.136.136,0,0,0-.058-.14c-.2-.133-1.968-1.285-2.656-.975a.485.485,0,0,0-.282.392.783.783,0,0,0,.22.74,1.669,1.669,0,0,0,1.116.306m1.163-.41c-1.026.2-1.794.169-2.088-.1a.517.517,0,0,1-.135-.495.2.2,0,0,1,.118-.176c.363-.166,1.385.334,2.106.774",
    transform: "translate(-144.266 -125.369)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102451",
    "data-name": "Path 102451",
    d: "M406.578,350.7a.139.139,0,0,0,.071-.019.141.141,0,0,0,.071-.12c0-.072.017-1.764-.614-2.329a.715.715,0,0,0-.587-.186.493.493,0,0,0-.474.388c-.141.663.909,1.93,1.465,2.248a.137.137,0,0,0,.069.018m-.967-2.382a.442.442,0,0,1,.306.122,3.144,3.144,0,0,1,.519,1.85c-.553-.446-1.206-1.4-1.12-1.8.014-.066.053-.145.231-.166a.539.539,0,0,1,.064,0",
    transform: "translate(-145.005 -124.601)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102452",
    "data-name": "Path 102452",
    d: "M334.09,347.038a.142.142,0,0,0,.126-.059.133.133,0,0,0-.006-.157c-.181-.23-1.761-2.215-2.615-2.27a.543.543,0,0,0-.056,0,.45.45,0,0,0-.379.222.724.724,0,0,0-.062.7c.34.777,2,1.31,2.964,1.558a.138.138,0,0,0,.028,0m-2.5-2.214c.471.03,1.457,1.03,2.131,1.835-1.3-.378-2.169-.847-2.36-1.283a.468.468,0,0,1,.046-.46.171.171,0,0,1,.151-.092h.033",
    transform: "translate(-118.514 -123.352)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102453",
    "data-name": "Path 102453",
    d: "M335.2,346.72a.131.131,0,0,0,.031,0,.137.137,0,0,0,.108-.084,3.668,3.668,0,0,0,.17-2.367,1.042,1.042,0,0,0-.609-.546c-.373-.135-.562-.01-.654.117-.39.536.342,2.25.852,2.832a.148.148,0,0,0,.1.049m-.561-2.782a.619.619,0,0,1,.168.039.758.758,0,0,1,.446.4,3.016,3.016,0,0,1-.1,1.915c-.472-.69-.909-1.973-.675-2.3a.157.157,0,0,1,.158-.06",
    transform: "translate(-119.624 -123.035)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102454",
    "data-name": "Path 102454",
    d: "M395.268,68.385c-.664,3.5-2.157,11.126.3,13.4,0,0-.933,3.552-7.418,3.679-7.13.14-3.428-3.467-3.428-3.467,3.886-1,3.769-3.884,3.076-6.577Z",
    transform: "translate(-137.389 -24.482)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102455",
    "data-name": "Path 102455",
    d: "M395.824,83.5a1.934,1.934,0,0,0-2.416-1.133,29.223,29.223,0,0,1-6.863,1.24,2.477,2.477,0,0,0-2.013,1.26l-2.754,4.856,15.7-1.9Z",
    transform: "translate(-136.68 -29.454)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102456",
    "data-name": "Path 102456",
    d: "M377.992,58.5a.276.276,0,0,0,.116-.056.28.28,0,0,0,.046-.392,2.717,2.717,0,0,0-2.285-1.074.283.283,0,0,0-.252.307.274.274,0,0,0,.3.248,2.169,2.169,0,0,1,1.8.87.275.275,0,0,0,.275.1",
    transform: "translate(-134.474 -20.398)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102457",
    "data-name": "Path 102457",
    d: "M376.239,64.715a12.891,12.891,0,0,1-1.438,3.177,2.023,2.023,0,0,0,1.706.157Z",
    transform: "translate(-134.182 -23.169)",
    fill: "#ff5652"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102458",
    "data-name": "Path 102458",
    d: "M376.971,62.938c.038.473-.181.88-.489.909s-.589-.331-.627-.8.181-.88.489-.908.589.33.627.8",
    transform: "translate(-134.558 -22.244)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102459",
    "data-name": "Path 102459",
    d: "M376.189,62.034l-1.159-.22s.652.832,1.159.22",
    transform: "translate(-134.264 -22.13)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102460",
    "data-name": "Path 102460",
    d: "M341.353,346.045l-5.691-1.963,4.015-12.664,5.692,1.963Z",
    transform: "translate(-120.17 -118.651)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102461",
    "data-name": "Path 102461",
    d: "M414.1,344.655h-5.876l-.532-13.608h5.876Z",
    transform: "translate(-145.959 -118.518)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102462",
    "data-name": "Path 102462",
    d: "M403.471,350.906h6.6a.458.458,0,0,1,.464.4l.679,5.223a.96.96,0,0,1-.957,1.045c-2.3-.04-3.408-.175-6.311-.175-1.786,0-4.4.186-6.865.186-2.412,0-2.563-2.438-1.534-2.66,4.619-.99,5.365-2.356,6.935-3.659a1.556,1.556,0,0,1,.987-.361",
    transform: "translate(-141.394 -125.628)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102463",
    "data-name": "Path 102463",
    d: "M330.617,347.327l6.108,2.872a.458.458,0,0,1,.26.556l-1.573,4.9a.963.963,0,0,1-1.326.507c-2.113-1.036-3.08-1.637-5.766-2.9-1.652-.777-5.151-2.221-7.434-3.294-2.232-1.05-1.344-3.268-.3-3.015,4.691,1.135,6.961.726,8.963.259a1.644,1.644,0,0,1,1.066.11",
    transform: "translate(-114.384 -124.207)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_149737",
    "data-name": "Group 149737",
    transform: "translate(217.355 212.771)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149736",
    "data-name": "Group 149736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149735",
    "data-name": "Group 149735",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102464",
    "data-name": "Path 102464",
    d: "M340.716,331.423l-2.153,6.785,5.775,1.706,2.071-6.528Z",
    transform: "translate(-338.564 -331.423)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_149740",
    "data-name": "Group 149740",
    transform: "translate(261.735 212.533)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149739",
    "data-name": "Group 149739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149738",
    "data-name": "Group 149738",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102465",
    "data-name": "Path 102465",
    d: "M413.571,331.053h-5.879l.277,7.014h5.878Z",
    transform: "translate(-407.693 -331.053)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_102466",
    "data-name": "Path 102466",
    d: "M416.4,90.378c2.446.487,5.106,9.209,5.106,9.209l-6.865,7.468s-5.779-8.128-4.629-11.181c1.2-3.18,3.5-6.071,6.388-5.5",
    transform: "translate(-146.735 -32.33)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_149743",
    "data-name": "Group 149743",
    transform: "translate(263.129 57.975)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149742",
    "data-name": "Group 149742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149741",
    "data-name": "Group 149741",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102467",
    "data-name": "Path 102467",
    d: "M416.4,90.378c2.446.487,5.106,9.209,5.106,9.209l-6.865,7.468s-5.779-8.128-4.629-11.181c1.2-3.18,3.5-6.071,6.388-5.5",
    transform: "translate(-409.865 -90.305)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_149746",
    "data-name": "Group 149746",
    transform: "translate(263.13 63.02)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149745",
    "data-name": "Group 149745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149744",
    "data-name": "Group 149744",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102468",
    "data-name": "Path 102468",
    d: "M412.565,98.851c-1.242-1.1-2.076-.751-2.639.157-.547,2.619,2.813,8.013,4.165,10.054.6-2.479,1.283-7.7-1.526-10.211",
    transform: "translate(-409.866 -98.163)",
    fill: "#407bff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_102469",
    "data-name": "Path 102469",
    d: "M371.038,91.762c-.442,2.571-.537,10.4,3.478,34.13l23.885-.469c-.456-9.7-.5-15.679,4.03-35.686a70.225,70.225,0,0,0-10.15-1.135,76.112,76.112,0,0,0-10.845.213c-3.47.384-7.284,1.139-9,1.5a1.782,1.782,0,0,0-1.394,1.448",
    transform: "translate(-132.761 -31.689)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_149749",
    "data-name": "Group 149749",
    transform: "translate(238.069 56.826)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149748",
    "data-name": "Group 149748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149747",
    "data-name": "Group 149747",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102470",
    "data-name": "Path 102470",
    d: "M371.038,91.762c-.442,2.571-.537,10.4,3.478,34.13l23.885-.469c-.456-9.7-.5-15.679,4.03-35.686a70.225,70.225,0,0,0-10.15-1.135,76.112,76.112,0,0,0-10.845.213c-3.47.384-7.284,1.139-9,1.5a1.782,1.782,0,0,0-1.394,1.448",
    transform: "translate(-370.829 -88.515)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_102471",
    "data-name": "Path 102471",
    d: "M392.939,54.162c.112,5.84.284,8.309-2.4,11.565-4.038,4.9-11.211,3.857-13.059-1.808-1.664-5.1-1.568-13.794,3.914-16.641a7.843,7.843,0,0,1,11.546,6.884",
    transform: "translate(-134.803 -16.591)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102472",
    "data-name": "Path 102472",
    d: "M376.825,51.28c4.636-.927,10.73-2.5,11.945-5.885s-12.524-6.036-11.945,5.885",
    transform: "translate(-134.901 -15.226)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102473",
    "data-name": "Path 102473",
    d: "M381.64,52.4c-.655-.327-1.855-2.366-1.106-5.909s6.349-6.717,10.735-4.22c-4.636,1.783-9.63,10.129-9.63,10.129",
    transform: "translate(-136.15 -14.815)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102474",
    "data-name": "Path 102474",
    d: "M381.606,48.938c-.784,3.281.028,5.626,1.279,6.833,0,0-3.237,21.148,12.863,18.846s6.7-26.347,2.945-29.842-13.841-5.264-17.087,4.163",
    transform: "translate(-136.508 -15.025)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102475",
    "data-name": "Path 102475",
    d: "M381.435,60.325a5.87,5.87,0,0,0-.876,3.524c.118,1.566,1.341,1.568,2.242.632.811-.843,1.688-2.868,1.234-4.063a1.409,1.409,0,0,0-2.6-.092",
    transform: "translate(-136.238 -21.304)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102476",
    "data-name": "Path 102476",
    d: "M386.4,146.351s3.644,40.227,7.315,62.866c2.965,18.286,5.474,61.066,5.474,61.066H407.2s2.613-41.756,1.057-59.869c-3.937-45.834,3.155-50.114-4.282-64.408Z",
    transform: "translate(-138.333 -52.272)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_149752",
    "data-name": "Group 149752",
    transform: "translate(250.439 107.528)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149751",
    "data-name": "Group 149751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149750",
    "data-name": "Group 149750",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102477",
    "data-name": "Path 102477",
    d: "M395.873,167.491c-2.089,3.069-4.877,6.6-5.775,10.344.72,6.785,1.563,14.289,2.475,21.505,2.2-6.071,5.976-18.2,3.3-31.849",
    transform: "translate(-390.098 -167.491)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_102478",
    "data-name": "Path 102478",
    d: "M363.089,146.5s-9.571,43.285-12.849,60.922c-3.41,18.346-11.326,59.92-11.326,59.92l7.99,4.11S361.676,221.4,363.65,212.15c5.209-19.3,21.9-66.061,21.9-66.061Z",
    transform: "translate(-121.334 -52.301)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102479",
    "data-name": "Path 102479",
    d: "M336.331,335.593l9.716,3.869,1.885-3.383-10.4-4.151Z",
    transform: "translate(-120.41 -118.833)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102480",
    "data-name": "Path 102480",
    d: "M404.6,337.633h10.206l.586-3.58-10.8-.365Z",
    transform: "translate(-144.851 -119.463)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102481",
    "data-name": "Path 102481",
    d: "M400.387,143.719l1.09,2.113c.084.164-.111.336-.387.342l-25.048.491c-.216,0-.394-.1-.409-.232L375.4,144.3c-.015-.148.171-.277.406-.281L400,143.548a.428.428,0,0,1,.39.171",
    transform: "translate(-134.398 -51.391)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102482",
    "data-name": "Path 102482",
    d: "M408.964,146.406l.648-.013c.129,0,.227-.071.218-.152l-.32-2.767c-.01-.081-.123-.145-.252-.143l-.648.012c-.129,0-.227.071-.218.152l.32,2.767c.01.081.123.145.252.143",
    transform: "translate(-146.208 -51.314)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102483",
    "data-name": "Path 102483",
    d: "M384.507,146.885l.648-.013c.129,0,.227-.071.218-.152l-.32-2.767c-.01-.081-.123-.145-.252-.143l-.648.012c-.129,0-.227.071-.218.152l.32,2.767c.01.081.123.145.252.143",
    transform: "translate(-137.452 -51.486)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102484",
    "data-name": "Path 102484",
    d: "M361.7,100.756a73.42,73.42,0,0,1-4.458,8.036c-.823,1.295-1.67,2.581-2.614,3.823-.454.628-.957,1.24-1.441,1.857-.522.6-1.025,1.21-1.594,1.8a15.862,15.862,0,0,1-1.9,1.778,19.977,19.977,0,0,1-2.092,1.426,30.475,30.475,0,0,1-4.3,2.105,43.984,43.984,0,0,1-8.912,2.474l-.772-2.874a76.511,76.511,0,0,0,7.723-3.726,32.343,32.343,0,0,0,3.454-2.214,15.272,15.272,0,0,0,1.466-1.231,11.043,11.043,0,0,0,1.233-1.363,60.638,60.638,0,0,0,4.685-6.957c.735-1.224,1.414-2.492,2.11-3.749s1.367-2.56,2-3.779Z",
    transform: "translate(-119.436 -35.142)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102485",
    "data-name": "Path 102485",
    d: "M369.666,91.067c-5.642,1.22-7.546,9.476-7.546,9.476l7.206,6.206s7.33-7.535,7.075-12.062c-.189-3.363-3.659-4.285-6.734-3.62",
    transform: "translate(-129.642 -32.531)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_149755",
    "data-name": "Group 149755",
    transform: "translate(232.478 58.334)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149754",
    "data-name": "Group 149754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149753",
    "data-name": "Group 149753",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102486",
    "data-name": "Path 102486",
    d: "M369.666,91.067c-5.642,1.22-7.546,9.476-7.546,9.476l7.206,6.206s7.33-7.535,7.075-12.062c-.189-3.363-3.659-4.285-6.734-3.62",
    transform: "translate(-362.12 -90.865)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_102487",
    "data-name": "Path 102487",
    d: "M333.8,136.38l-5.709,2.9L325.98,134.4s5.049-1.167,7.22-.081Z",
    transform: "translate(-116.704 -47.92)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102488",
    "data-name": "Path 102488",
    d: "M324.659,140.578l-2.215-3.306,2.27-2.573,2.116,4.881Z",
    transform: "translate(-115.438 -48.223)",
    fill: "#ff8b7b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/Review.8b177a3cdff14dcc5938148556eb0904.svg";
export { ForwardRef as ReactComponent };